import React from 'react';
import { OptionsAssetIcon, normalizeAssetKey } from './OptionsAssetIcon';

const LEADING_NATIVE_VALUE_REGEX = /^(≈\s*)?([+-]?)(\d[\d.,]*|[.,]\d+)\s+([A-Z]{2,10})(.*)$/i;

const parseLeadingNativeValue = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  const match = trimmed.match(LEADING_NATIVE_VALUE_REGEX);
  if (!match) return null;

  return {
    approxPrefix: match[1] || '',
    sign: match[2] || '',
    amount: match[3],
    assetKey: normalizeAssetKey(match[4]),
    assetCode: String(match[4] || '').toUpperCase(),
    suffix: match[5] || '',
  };
};

export const OptionsMonetaryText = ({ value, iconSize = 16 }) => {
  const parsed = parseLeadingNativeValue(value);

  if (!parsed) return value;

  return (
    <span className="inline-flex flex-wrap items-center gap-1.5 align-middle">
      {parsed.approxPrefix ? <span>{parsed.approxPrefix.trim()}</span> : null}
      <OptionsAssetIcon assetKey={parsed.assetKey} size={iconSize} className="shrink-0" />
      <span className="tabular-nums">{`${parsed.sign}${parsed.amount}`}</span>
      <span className="font-semibold tracking-[0.16em] opacity-72">{parsed.assetCode}</span>
      {parsed.suffix ? <span className="opacity-80">{parsed.suffix}</span> : null}
    </span>
  );
};

export default OptionsMonetaryText;